import { Layout } from "antd";
import "./DiagnoseLayout.scss";

const { Content } = Layout;
const DiagnoseLayout: React.FC = (props) => {
  const { children } = props;

  return (
    <Layout className="diagnose-layout">
      <Content>{children}</Content>
    </Layout>
  );
};

export default DiagnoseLayout;
